import { call } from "@saas/api-client";
import { useAsync } from "@saas/ui";
import { api } from "./api";

/** Tenant id -> name, for tables that only carry ids (platform data has no tenant names). */
export function useTenantNames(): (tenantId: string | null | undefined) => string {
  const tenants = useAsync(() => call(api.GET("/api/tenants")), []);
  return (tenantId) => {
    if (!tenantId) return "—";
    return tenants.data?.find((t) => t.id === tenantId)?.name ?? tenantId;
  };
}
